import { useInvestmentListSummary } from 'Store';

export function useLoginRedirectDefault() {
  async function redirectOnLoginDefault(replace?: boolean) {
    const {
      loadInvestmentListSummary,
      isSomeInvestment,
    } = useInvestmentListSummary();
    await loadInvestmentListSummary();
    const path = isSomeInvestment.value ? '/portfolio/overview' : '/profile/accounts';
    if (replace) window.location.replace(path);
    else window.location.href = path;
  }

  return {
    redirectOnLoginDefault,
  };
}
